import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HowToPlayService {
  // URLs from the acceptance criteria
  public urls = {
    dashboard:
      'https://azcollaboration.sharepoint.com/:p:/r/sites/StrategyChangeandResultsTeam/_layouts/15/guestaccess.aspx?share=Ec6y7HMtxBhCkNJfgQJlE0EBXikkeNQQyEr5T0pfJHrD0Q&e=ezLTI1&nav=eyJzSWQiOjIxNDc0ODM0ODMsImNJZCI6MjU0ODExNDM0Mn0',
    prepare:
      'https://azcollaboration.sharepoint.com/:p:/r/sites/StrategyChangeandResultsTeam/_layouts/15/guestaccess.aspx?share=Ec6y7HMtxBhCkNJfgQJlE0EBXikkeNQQyEr5T0pfJHrD0Q&e=grAuzq&nav=eyJzSWQiOjIxNDc0ODM0ODcsImNJZCI6OTgwNzA1MDg5fQ',
    decide:
      'https://azcollaboration.sharepoint.com/:p:/r/sites/StrategyChangeandResultsTeam/_layouts/15/guestaccess.aspx?share=Ec6y7HMtxBhCkNJfgQJlE0EBXikkeNQQyEr5T0pfJHrD0Q&e=Xdx4rU&nav=eyJzSWQiOjIxNDc0ODM0ODgsImNJZCI6MjY5ODMzMDgzfQ',
  };

  constructor(public router: Router) {}

  /**
   * Opens the appropriate "How to Play" guide based on the current route
   */
  openHowToPlayGuide(): void {
    const currentUrl = this.router.url;
    let targetUrl: string;

    if (currentUrl.includes('/dashboard') || currentUrl === '/') {
      targetUrl = this.urls.dashboard;
    } else if (currentUrl.includes('/prepare')) {
      targetUrl = this.urls.prepare;
    } else if (currentUrl.includes('/decide')) {
      targetUrl = this.urls.decide;
    } else {
      // Default to dashboard URL if route doesn't match
      targetUrl = this.urls.dashboard;
    }

    // Open in new tab
    window.open(targetUrl, '_blank');
  }

  /**
   * Gets the URL for a specific section
   */
  getUrlForSection(section: 'dashboard' | 'prepare' | 'decide'): string {
    return this.urls[section];
  }
}
